import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player/lazy";
import { Container, Grid, Typography } from "@material-ui/core";
import RectangleShape from "./RectangleShape.svg";

const useStyles = makeStyles((theme) =>
  createStyles({
    bgDrakBlue: {
      background: '#01305F',
      float: 'left',
      width: '100%',
      color: '#ffffff',
      paddingBottom: '15%',
      position: 'relative',
      paddingTop: '5%',

      [ theme.breakpoints.down("sm") ]: {
        padding: '100px 15px 100px !important'
      },
    }
  }),
);
export default function LearnMore() {
  const classes = useStyles();
  return (
    <div className={classes.bgDrakBlue + " textCenter mt40 floatLeft w100"} style={{padding: '300px 15px 100px'}}>
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={12} lg={12}>
        <img alt="rectangle shape" className="rectangleShapeBefore" src={RectangleShape}/>
        <Typography variant="h1">
          Learn more about <span style={{display:'inline-flex'}}>Kai-Zen<sup>®</sup></span>
        </Typography>
        <Typography variant="subtitle1" className="floatLeft w100">
          Watch this short video to learn exactly how we make leverage work for you.
        </Typography>
        <ReactPlayer
          className="mt40 floatLeft w100 learnMoreVideo"
          controls={true}
          loop={true}
          url={'https://vimeo.com/339578397'}
          playsinline={true}
        />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
